import React from 'react'

export default function Name (props) {
    const {aliases = {}, member} = props
    if (member.SpreadsheetID) return <p>{aliases[member._id] || member.Name || member.Email}</p>
    return <p><em>{member.Email} (invited)</em></p>
}
